<template>
  <div>

    <div class="q-mt-md">
      <div class="row-reverse">
        <q-btn
          color="primary"
          label="Add Crop"
          @click="onAdd"
          class="q-mb-md q-ml-lg"
        />
      </div>
    </div>
    <BaseTable
      :rows="formattedCrops"
      :columns="columns"
      :total-rows="totalCrops"
      :get-edit-url="getEditUrl"
    />
  </div>
</template>

<script>
import BaseTable from '@/components/BaseTable';
import axios from 'axios';

export default {
  name: 'CropTable',
  components: {
    BaseTable
  },
  data() {
    return {
      crops: [],
      totalCrops: 0,
      columns: [
        { name: 'id', align: 'left', label: 'ID', field: 'id', sortable: true },
        { name: 'crop', align: 'left', label: 'Crop', field: 'crop', sortable: true },
        { name: 'season', align: 'left', label: 'Season', field: 'season', sortable: true },
        { name: 'add_date', align: 'left', label: 'Add Date', field: 'add_date', sortable: true },
        { name: 'edit_date', align: 'left', label: 'Edit Date', field: 'edit_date', sortable: true },
        { name: 'actions', align: 'center', label: 'Actions', field: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    formattedCrops() {
      return this.crops.map(crop => ({
        ...crop,
        add_date: new Date(crop.add_date).toLocaleDateString(),
        edit_date: new Date(crop.edit_date).toLocaleDateString()
      }));
    }
  },
  created() {
    this.fetchCrops();
  },
  methods: {
    fetchCrops() {
      axios
        .get('/api/v1/crop/crops/')
        .then(response => {
          this.crops = response.data;
          this.totalCrops = response.data.length;
        })
        .catch(error => {
          console.error('Error fetching crops:', error);
        });
    },
    onAdd() {
      this.$router.push('/crops/add');
    },
    getEditUrl(row) {
      return `/crop/edit/${row.id}`;
    }
  },
  watch: {
    crops() {
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
/* Add any specific styles for the CropTable here */
</style>
